import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full fixed bg-black bg-opacity-25 z-10 top-0 left-0 right-0 bottom-0 flex items-center justify-center" }
const _hoisted_2 = { class: "t-18m md:t-22m lg:t-28m text-wrh-blue-darken mt-6" }

import {
  computed, PropType, ref, toRefs,
} from 'vue';
import { onClickOutside } from '@vueuse/core';
import SuccessIcon from '@/components/icons/CheckIcon.vue';
import CloseIcon from '@/components/icons/CloseIcon.vue';
import ErrorIcon from '@/components/icons/AlertIcon.vue';
import { Response, Alert } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  props: {
  alertType: {
    type: String as PropType<Response>,
    required: true,
  },
},
  emits: ['closeAlert'],
  setup(__props, { emit }) {

const props = __props


const { alertType } = toRefs(props);
const alertTarget = ref(null);


const message = computed(() => {
  switch (alertType.value) {
    case Response.SUCCESS:
      return Alert.Success;

    case Response.SENT:
      return Alert.EmailSent;

    case Response.USERNOTFOUND:
      return Alert.UserNotExist;

    case Response.INVITESENT:
      return Alert.InviteSent;

    case Response.EMAILERROR:
      return Alert.EmailError;

    case Response.USER_ALREADY_EXIST:
      return Alert.BuyerAlreadyExist;

    case Response.WARRANTY_SUBMISSION_NOT_ALLOWED:
      return Alert.WarrantyNotSubmitted;

    case Response.BUYER_NOT_VERIFIED:
      return Alert.BuyerNotVerified;

    case Response.ADDITIONAL_BUYER_ERROR:
      return Alert.AdditionalBuyerError;

    default:
      return Alert.Error;
  }
});

const icon = computed(() => {
  if ([Response.SUCCESS, Response.SENT, Response.INVITESENT, Response.USER_ALREADY_EXIST].includes(alertType.value)) {
    return SuccessIcon;
  }
  return ErrorIcon;
});

onClickOutside(alertTarget, () => {
  emit('closeAlert');
});

const closeAlert = () => {
  emit('closeAlert');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg-white rounded p-10 w-l max-w-xl relative text-center",
      ref: (_value, _refs) => {
        _refs['alertTarget'] = _value
        alertTarget.value = _value
      }
    }, [
      _createVNode(CloseIcon, {
        class: "absolute top-0 right-0 bg-white rounded-full p-1 cursor-pointer",
        onClick: closeAlert,
        color: "black"
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon)), {
        class: _normalizeClass(['w-12 m-auto', _unref(alertType) === _unref(Response).Error ? 'text-wrh-red-medium' : 'text-wrh-green-medium'])
      }, null, 8, ["class"])),
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(message)), 1)
    ], 512)
  ]))
}
}

})